import React from 'react'
import { Seller } from './style'

export default ({ value }) => (
    <Seller>{value}</Seller>
)
